import gql from 'graphql-tag';

export const getContactListsForDropdown = gql`
  query getContactListsForDropdown {
    getContactListsForDropdown {
      id
      name
      additionalResourceListTypeId
    }
  }
`;
